import { SnackbarActions } from './SnackbarStore.reducer'

export interface SnackbarOptions {
  message: string,
}

export const openSnackbar = (payload: SnackbarOptions) => ({ type: SnackbarActions.OPEN_SNACKBAR, payload })

const SnackbarActionCreators = {
  openSnackbar,
  closeSnackbar: () => ({ type: SnackbarActions.CLOSE_SNACKBAR }),
}

export const SNACKBAR_GENERAL_ERROR_MESSAGE = `An error has occurred. Please try again later.`

export default SnackbarActionCreators
